export const getAllTemplatesResponse = {
  data: [
    {
      name: "job_notification",
      language: "en",
      category: "MARKETING",
      id: "1046602571696471",
      allow_category_change: false,
      status: "APPROVED",
      components: [
        {
          type: "BODY",
          text: "Hi {{1}},\n\n Great news ! We have recommended a job that fits your job requirements.\n\nJob Designation - *{{2}}*\nCompany Name - *{{3}}*\nSalary Range - *{{4}}*\nCity - *{{5}}*\nState - *{{6}}*\nCountry - *{{7}}* \n\nVizarto Team",
          example: {
            body_text: [
              [
                "Rohit",
                "Python Developer",
                "Zithas Technologies",
                "22000-30000 per month",
                "Vadodara",
                "Gujarat",
                "India",
              ],
            ],
          },
        },
      ],
    },
    {
      name: "verify_code_1",
      language: "en",
      category: "AUTHENTICATION",
      id: "2438561249888801",
      allow_category_change: false,
      status: "APPROVED",
      components: [
        {
          type: "BODY",
          text: "*{{1}}* is your verification code.",
          example: {
            body_text: [["123456"]],
          },
        },
        {
          type: "BUTTONS",
          buttons: [
            {
              type: "URL",
              text: "Copy code",
              url: "https://www.whatsapp.com/otp/code/?otp_type=COPY_CODE&code=otp{{1}}",
              example: [
                "https://www.whatsapp.com/otp/code/?otp_type=COPY_CODE&code=otp123456",
              ],
            },
          ],
        },
      ],
    },
  ],
  paging: {
    cursors: {
      before:
        "QVFIVHJXczdacno4VHMtLW5mU3lhNy1GUjktclJUZAk56aFpwNUR4eF9zaHljUWFXU211ZAHZA6ZA0tBaUotUF9xYm1qMDB6bVBKQndSQkFHYzdlcmctMGxDTzFB",
      after:
        "QVFIVEhDRmJwc1ZAGemRuQU9LQkltVDhXVU5DOTloeEVzV0EzYlVOLWxVZAjg2UEd6MGVtdVJpXy1FamhwanpFTmg0TWtWaDBfVm5EdzQ4bk9qLVRWbV80TDRR",
    },
  },
}
